import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { Alert, Button, Link, Typography } from '@mui/material';
import { useMutationCallback } from 'shared/api/hooks';
import { TextInputWrapper } from 'shared/components/fields/text';
import { preventDefault, useBox, useCallbacks, useMounted } from 'shared/hooks/utils';
import { ControlWithoutLabel } from 'shared/components/fields/control/without-label';
import { LoadingButton } from '@mui/lab';
import { useSetInitialEmail } from 'shared/api/set-initial-email';
import { debounce } from 'throttle-debounce';
import { useAppSelector } from 'shared/hooks/redux/hooks';
const Suggestion = memo((props) => {
    const { suggestion, onAccept } = props;
    const onClick = useCallbacks([preventDefault, onAccept]);
    return (_jsxs(_Fragment, { children: [_jsxs(Typography, { color: "info", children: ["\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0432\u044B \u0438\u043C\u0435\u043B\u0438 \u0432 \u0432\u0438\u0434\u0443 ", suggestion, "?"] }), _jsx(Link, { onClick: onClick, href: "#", children: "\u0414\u0430, \u0437\u0430\u043C\u0435\u043D\u0438\u0442\u044C" })] }));
});
export const FillDialog = memo(function EmailFillDialog(props) {
    const { open, onClose } = props;
    const { email } = useAppSelector((state) => state.account);
    const [text, setText] = useState(email ?? '');
    const boxedText = useBox(text);
    const [suggestion, setSuggestion] = useState(null);
    const boxedSuggestion = useBox(suggestion);
    const [loadSuggestions, , responseSuggestion] = useMutationCallback('check_email');
    const [setInitialEmail, isLoading, response, error, isSendRequest] = useSetInitialEmail();
    useEffect(() => {
        if (isSendRequest && response?.ok) {
            onClose();
        }
    }, [isSendRequest, response]);
    const isMounted = useMounted();
    useEffect(() => {
        if (isMounted.current) {
            if (responseSuggestion != null) {
                setSuggestion(responseSuggestion.suggest);
            }
        }
    }, [responseSuggestion]);
    const debouncedLoadSuggestions = useMemo(() => debounce(500, () => {
        loadSuggestions({ email: boxedText.current });
    }), [loadSuggestions]);
    const onChange = useCallback((value) => {
        setText(value);
        debouncedLoadSuggestions();
    }, [debouncedLoadSuggestions]);
    const onSave = useCallback(() => setInitialEmail({ email: boxedText.current }), []);
    const onAccept = useCallback(() => {
        if (boxedSuggestion.current != null) {
            setText(boxedSuggestion.current);
        }
        setSuggestion(null);
    }, []);
    const field = useCallback((input_props) => (_jsx(TextInputWrapper, { ...input_props, autoFocus: true, type: "email", fullWidth: true })), []);
    return (_jsxs(MessageBox, { open: open, onClose: onClose, isInfo: true, title: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0412\u0430\u0448 E-Mail", footer: _jsxs(_Fragment, { children: [_jsx(Button, { onClick: onClose, children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), _jsx(LoadingButton, { loading: isLoading, onClick: onSave, children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" })] }), children: [_jsx(ControlWithoutLabel, { value: text, onChange: onChange, onComplete: onSave, field: field, validation_result: error, validation_warnings_result: null }), "\u00A0", suggestion && (_jsx(Alert, { severity: "info", children: _jsx(Suggestion, { suggestion: suggestion, onAccept: onAccept }) }))] }));
});
